// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__xqvdA","detailsWrapper":"styles_detailsWrapper__RmIo+","radio":"styles_radio__Ww-Eg","text":"styles_text__ZWQet"};